import React from 'react';
import css from './index.module.scss';
import EcoLink from 'eco-design/base/eco-link';
import { useLang } from '@/i18n';

interface Props {}

const A: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.A');

    return (
        <section
            id="rapid-mag-A"
            className={`rapid-mag-A ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-A'}
            data-section-title={t('title')}
        >
            <div className="img">
                <picture className="picture">
                    {/* <source media={`(min-width: 1025px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1761814678853/PC.webp'} type="image/webp" />
                    <source media={`(max-width: 1024px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1761810965280/M.webp'} type="image/webp" /> */}
                    <source media={`(max-width: 1024px)`} srcSet={'https://websiteoss.ecoflow.com/figma-uploads/1762477479480-e0hmjj-compressed-768/375.jpg'} />
                    <img
                        // @ts-ignore
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/figma-uploads/1762477465774-4yq8r6-compressed-1920/1366.jpg'}
                        alt={t('title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className="info">
                <p className="label">{t('label')}</p>
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <EcoLink className="btn GtmModuleData-btn-href" href="#PowerSolution">
                    {t('btn')}
                </EcoLink>
            </div>
        </section>
    );
};
export default A;
